import * as React from 'react';
import { cn } from './lib/utils';
import { ICON_PX } from './lib/iconSizes';

/**
 * Metadata row for detail panels. Renders icon + label + value inline.
 * Use in a 2-column grid: `grid grid-cols-2 gap-x-4 gap-y-2 text-body-sm`
 *
 * @param {import('lucide-react').LucideIcon} icon - Lucide icon component
 * @param {string} label - Metadata label
 * @param {React.ReactNode} value - Metadata value
 * @param {boolean} highlight - Render value in red-critical for warning states
 */
function DetailRow({ icon: Icon, label, value, highlight = false, className }) {
  return (
    <div className={cn('flex items-center gap-1.5 min-w-0', className)}>
      {Icon && <Icon size={ICON_PX.sm} className="text-text-muted shrink-0" />}
      <span className="text-text-muted shrink-0">{label}</span>
      <span className={cn('font-medium truncate', highlight ? 'text-red-critical' : 'text-text-dark')}>
        {value ?? '—'}
      </span>
    </div>
  );
}

export { DetailRow };
export default DetailRow;
